export const insertAtPosition = (array, element, index) => {
    return [
        ...array.slice(0, index),
        element,
        ...array.slice(index),
    ];
};
